<script setup lang="ts">
    import { computed, toRef } from 'vue'

    import { KendoChart } from '@Kendo/Components/KendoChart'
    import { CriterionSelectorDialogViewModel } from '@Criteria/Hierarchies/Components/CriterionSelectorDialog'
    import CriterionSelectorDialog from '@Criteria/Hierarchies/Components/CriterionSelectorDialog.vue'
    import type { SensitivityAnalysisChartDialogViewModel } from '@Evaluation/ValueAnalysis/Components/SensitivityAnalysisChartDialog'

    // ---------------- props ----------------

    const props = defineProps<{
        viewModel: SensitivityAnalysisChartDialogViewModel
    }>()

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- local state ----------------

    const criterionSelectorDialog = new CriterionSelectorDialogViewModel()

    // ---------------- computed ----------------

    const opened = computed(() => vm.value?.opened ?? false)

    const chart = computed<KendoChart>(() => vm.value.chart)

    const selectedCriterionName = computed<string | null>(() =>
        vm.value.selectedCriterion?.Name ?? null
    )

    const goalSelected = computed<boolean>(() => vm.value.goalSelected)

    const criterionId = computed<number>({
        get: () => vm.value.criterionId,
        set: val => { vm.value.criterionId = val }
    })

    // ---------------- actions ----------------

    function showCriterionSelector()
    {
        criterionSelectorDialog.show(criterionId.value, vm.value.criteria)
    }

    function handleChangeCriterion(id: number)
    {
        if (id !== criterionId.value)
        {
            criterionId.value = id
            vm.value.setChartData()
        }
    }

    function close()
    {
        vm.value.close()
    }
</script>


<template>
    <div>
        <div class="modal-mask" v-if="opened">
            <div class="modal-wrapper">
                <div class="modal-dialog modal-xl modal-dialog-scrollable">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Sensitivity analysis</h5>
                            <button type="button" class="close" @click="close">&times;</button>
                        </div>

                        <div class="modal-body">
                            <div>
                                <p>Criterion: <a class="text-primary" @click="showCriterionSelector">{{selectedCriterionName}}</a></p>

                                <div class="alert alert-warning" role="alert" v-if="goalSelected">
                                    Please select a criterion. Sensitivity analysis in the context of root is not available.
                                </div>
                            </div>

                            <br />

                            <div style="max-height: calc(100vh-200px); overflow: auto;">
                                <div id="Chart-SensitivityAnalysisChart"></div>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button @click="close" type="button" class="btn btn-outline-secondary">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <CriterionSelectorDialog :viewModel="criterionSelectorDialog"
                                 @confirm-selection="handleChangeCriterion" />
    </div>

</template>

